interface CommentItem {
  avatar: string;
  name: string;
  time: string;
  manga: string;
  content: string;
  likes: number;
}

const comments: CommentItem[] = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20circle%20with%20soft%20gradient%20coral%20and%20cream%20colors%2C%20minimalist%20avatar%20style%2C%20no%20text%20no%20face%2C%20clean%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '漫画迷小鹿',
    time: '2小时前',
    manga: '我的温柔暴君',
    content: '这部真的太好看了！画风细腻剧情也超棒，每次更新都第一时间追，完全停不下来。推荐给所有喜欢恋爱韩漫的朋友！',
    likes: 328,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20circle%20with%20soft%20gradient%20amber%20and%20cream%20colors%2C%20minimalist%20avatar%20style%2C%20no%20text%20no%20face%2C%20clean%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '二次元老司机',
    time: '5小时前',
    manga: '重生之都市修仙',
    content: '追了两年了，剧情越来越精彩！国漫现在质量真的不输日韩，女神漫画更新速度也超快，每天都有新章节看，赞！',
    likes: 256,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20circle%20with%20soft%20gradient%20muted%20sage%20and%20cream%20colors%2C%20minimalist%20avatar%20style%2C%20no%20text%20no%20face%2C%20clean%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '深夜追漫人',
    time: '昨天',
    manga: '暗黑童话',
    content: '悬疑类韩漫天花板！每一话都有反转，作者的伏笔埋得太绝了。女神漫画的下拉式阅读体验也很流畅，强烈安利。',
    likes: 189,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20circle%20with%20soft%20gradient%20coral%20pink%20and%20cream%20colors%2C%20minimalist%20avatar%20style%2C%20no%20text%20no%20face%2C%20clean%20design&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '樱花飘落',
    time: '昨天',
    manga: '邻家天使',
    content: '日漫校园题材永远的神！画风太治愈了，每天下班回家看一话心情都会变好。感谢女神漫画免费提供这么好的资源～',
    likes: 412,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
          漫友评论
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8 md:mb-10">
          来自真实读者的阅读感受与推荐
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                    <span className="text-xs text-foreground-500">{comment.time}</span>
                  </div>
                  <p className="text-xs text-primary-600 font-medium mt-0.5">
                    在看《{comment.manga}》
                  </p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-100">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-thumb-up-line text-xs"></i>
                  </span>
                  {comment.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}